//import TodoDataFunc from "@/pcomponents/common/content/todo/data/func/data_func";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';

class TodoDataFunc {
  static default_todo_info = {
    "a_ymd": "",
    "a_seq": "",
    "a_is_mcomp_public": "1",
    "a_par_mcomp_seq": "",
    "a_sort": "study",//할일구분(homework:숙제,study:학습)
    "a_par_id": "",
    "a_par_seq": "",

    "a_writer_mcomp_seq": "",
    "a_writer_mcomp_user_seq": "",
    "a_writer_seq": "",
    "a_writer_name": "",
    "a_stu_mcomp_seq": "",
    "a_stu_mcomp_user_seq": "",
    "a_stu_seq": "",
    "a_stu_name": "",

    "a_start_date": "",
    "a_start_date_last": "",
    "a_end_date": "",
    "a_is_reserve": "1",
    "a_reserve_start_date": "",
    "a_reserve_end_date": "",

    "a_subject": "",
    "a_title": "",
    "a_content": "",

    "a_success_sort": "amount",//목표구분(time:시간,amount:분량,공백:없음)
    "a_amount_sort": "개",//단위(개,페이지..)
    "a_amount_num": "",//달성량
    "a_success_amount": "1",//성공기준
    "a_success_time_sec": "",//목표시간
    "a_time_sec": "",//경과시간
    "a_is_success": "",
    "a_state": "ready",//상태(ready:준비,ing:하는중,stop:중지,complete:성공)

    "a_result_memo": "",
    "a_is_need_photo": "1",
    "a_add_file_type": "",
  };
  static get_default_todo_info(inData: any) {
    let opt_obj = {
      row_data: {},
      select_date: "",
      mcomp_seq: "",
      mcomp_user_seq: "",
      mcomp_user_name: "",
      main_user_seq: "",
      ...inData
    };
    let this_obj = this;
    let ymd_str = "";
    if (opt_obj.select_date) {
      ymd_str = strFunc.str_replace("-", "", opt_obj.select_date.substring(0, 10));
    }
    let row_data: any = {
      ...this_obj.default_todo_info,
      "a_ymd": ymd_str,
      "a_reserve_start_date": opt_obj.select_date,
      "a_reserve_end_date": opt_obj.select_date,

      "a_par_mcomp_seq": opt_obj.mcomp_seq,
      "a_writer_mcomp_seq": opt_obj.mcomp_seq,
      "a_writer_mcomp_user_seq": opt_obj.mcomp_user_seq,
      "a_writer_seq": opt_obj.mcomp_user_seq,
      "a_writer_name": opt_obj.mcomp_user_name,
      "a_stu_mcomp_seq": opt_obj.mcomp_seq,
      ...opt_obj.row_data
    };
    return row_data;
  }
}
export default TodoDataFunc;